import { useState } from 'react'
import { useToast } from '@chakra-ui/react'
import { doc, updateDoc } from 'firebase/firestore'
import isEqual from 'lodash/isEqual'
import { getEffectiveServices } from '../../../../../utils/firebaseServiceContext'

export const useMedicalHistorySave = (uid: string) => {
  const [isSaving, setIsSaving] = useState(false)
  const toast = useToast()

  const saveHistory = async (historyData: any[], fieldName: string) => {
    console.log('Function executing')
    setIsSaving(true)
    
    if (!uid) {
      alert('Not logged in!')
      setIsSaving(false)
      return
    }
    
    const userRef = doc(getEffectiveServices().firestore, 'users', uid)
    await updateDoc(userRef, {
      [`medicalDetails.${fieldName}`]: historyData,
    })
    
    toast({
      title: 'Success',
      description: `Your ${fieldName.replace(/([A-Z])/g, ' $1')} data has been successfully saved.`,
      status: 'success',
      duration: 5000,
      isClosable: true,
    })
    
    setIsSaving(false)
  }

  const createSaveFunction = (
    historyData: any[],
    initialData: any[],
    fieldName: string
  ) => {
    return () => {
      if (!isEqual(historyData, initialData)) {
        saveHistory(historyData, fieldName)
      }
    }
  }

  return {
    isSaving,
    saveHistory,
    createSaveFunction,
  }
}

export default useMedicalHistorySave
